/** 실제 터치에서 길게 누르면 contextmenu와 같은 좌표로 메뉴를 연다. */

const HOLD_MS = 500;
const MOVE_PX = 8;
const CLICK_SUPPRESS_MS = 700;

const pressByEl = new WeakMap();
let suppressClick = false;

if (typeof document !== 'undefined') {
  document.addEventListener('click', (event) => {
    if (!suppressClick) return;
    const el = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (el?.closest?.('[data-submat-menu]')) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);
}

const armClickSuppress = () => {
  suppressClick = true;
  window.setTimeout(() => { suppressClick = false; }, CLICK_SUPPRESS_MS);
};

const clearPress = (el) => {
  const state = el ? pressByEl.get(el) : null;
  if (!state) return;
  window.clearTimeout(state.timer);
  pressByEl.delete(el);
};

/** 버튼·입력 위가 아니면 0.5초 뒤 onFire({ clientX, clientY, target }) */
export const bindLongPress = (onFire) => ({
  onTouchStart(event) {
    if (event.target?.closest?.('button, input, textarea, select, a, [role="button"]')) return;
    const touch = event.touches?.[0];
    const el = event.currentTarget;
    if (!touch || !el || !onFire) return;
    event.stopPropagation();
    clearPress(el);
    const point = { x: touch.clientX, y: touch.clientY };
    const target = event.target;
    const timer = window.setTimeout(() => {
      if (!pressByEl.has(el)) return;
      pressByEl.delete(el);
      armClickSuppress();
      onFire({
        preventDefault() {},
        stopPropagation() {},
        clientX: point.x,
        clientY: point.y,
        target,
      });
    }, HOLD_MS);
    pressByEl.set(el, { timer, ...point });
  },
  onTouchMove(event) {
    const el = event.currentTarget;
    const state = el ? pressByEl.get(el) : null;
    const touch = event.touches?.[0];
    if (!state || !touch) return;
    if (Math.abs(touch.clientX - state.x) > MOVE_PX || Math.abs(touch.clientY - state.y) > MOVE_PX) {
      clearPress(el);
    }
  },
  onTouchEnd(event) {
    clearPress(event.currentTarget);
  },
  onTouchCancel(event) {
    clearPress(event.currentTarget);
  },
});
